/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Go_To_ItemInputs */

const he_account_reviews_go_to_item = /** @type {(inputs: Account_Reviews_Go_To_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עבור למוצר`)
};

const en_account_reviews_go_to_item = /** @type {(inputs: Account_Reviews_Go_To_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to item`)
};

/**
* | output |
* | --- |
* | "Go to item" |
*
* @param {Account_Reviews_Go_To_ItemInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_go_to_item = /** @type {((inputs?: Account_Reviews_Go_To_ItemInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Go_To_ItemInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_go_to_item(inputs)
	return en_account_reviews_go_to_item(inputs)
});